var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.origin_list, function(item) {
              return item.origin_id !== -1
                ? _c(
                    "div",
                    {
                      key: item.origin_id,
                      staticClass: "status",
                      class: { active: _vm.origin === item.origin_id },
                      on: {
                        click: function($event) {
                          return _vm.selectOrigin(item.origin_id)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(item.origin_name) + "\n    ")]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: _vm.search_type,
                                      callback: function($$v) {
                                        _vm.search_type = $$v
                                      },
                                      expression: "search_type"
                                    }
                                  },
                                  _vm._l(_vm.search_options, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.name,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-left": "-15px",
                                  width: "165px"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入搜索内容" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.search_value,
                                    callback: function($$v) {
                                      _vm.search_value = $$v
                                    },
                                    expression: "search_value"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "计费方式" },
                                    model: {
                                      value: _vm.form.billing_mehtod,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "billing_mehtod",
                                          $$v
                                        )
                                      },
                                      expression: "form.billing_mehtod"
                                    }
                                  },
                                  _vm._l(_vm.billing_mehtods, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "理赔类型" },
                                    model: {
                                      value: _vm.form.type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "type", $$v)
                                      },
                                      expression: "form.type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.resData.type, function(item) {
                                      return _c("el-option", {
                                        key: item.claims_type_id,
                                        attrs: {
                                          label: item.title,
                                          value: item.claims_type_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "提交时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "审核时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.check_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "check_time", $$v)
                                    },
                                    expression: "form.check_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "理赔月份：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    format: "yyyy-MM",
                                    type: "month",
                                    placeholder: "选择月"
                                  },
                                  model: {
                                    value: _vm.form.shipping_month,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipping_month", $$v)
                                    },
                                    expression: "form.shipping_month"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "状态" },
                                    model: {
                                      value: _vm.form.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "status", $$v)
                                      },
                                      expression: "form.status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.status_options, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.name,
                                          value: item.key
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { slot: "trigger", size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.dialogFormVisible = true
                      }
                    },
                    slot: "trigger"
                  },
                  [_vm._v("批量审核")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { slot: "trigger", size: "mini", type: "primary" },
                    on: { click: _vm.outputdetail },
                    slot: "trigger"
                  },
                  [_vm._v("理赔明细导出")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { slot: "trigger", size: "mini", type: "primary" },
                    on: { click: _vm.output },
                    slot: "trigger"
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addColor
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "claims_id",
                            label: "理赔批次号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "work_count",
                            label: "工单数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "num",
                            label: "商品数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "refund_money",
                            label: "退款金额"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "理赔类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.f_claims_type) +
                                        "/\n              " +
                                        _vm._s(scope.row.claims_type) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1873936148
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "",
                            label: "计费方式/计费比例/商品理赔"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row.claims_billing_method
                                        ) +
                                        "/\n              " +
                                        _vm._s(scope.row.billing_rate) +
                                        "/" +
                                        _vm._s(scope.row.money) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2261850564
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_fee",
                            label: "理赔运费"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "claims_fee",
                            label: "理赔费用"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipping_month",
                            label: "理赔月份"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "apply_admin",
                            label: "提交人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "提交时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "remark",
                            label: "提交备注"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "claims_detail_status",
                            label: "状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "check_admin",
                            label: "审核人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "check_time",
                            label: "审核时间"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.check_time ==
                                            "1970-01-01 08:00:00"
                                            ? ""
                                            : scope.row.check_time
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4251450980
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "check_remark",
                            label: "审核备注"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "dbid",
                            label: "操作",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDetail(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看详情")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1028591782
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ,sizes",
                        total: _vm.resData.count,
                        "page-size": _vm.form.pagesize,
                        "page-sizes": [50, 100, 200, 500, 1000]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "批量审核",
                visible: _vm.dialogFormVisible,
                width: "30%",
                center: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogFormVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.form } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { label: "审核状态:" }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "2", border: "", size: "medium" },
                          model: {
                            value: _vm.form.batchstatus,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "batchstatus", $$v)
                            },
                            expression: "form.batchstatus"
                          }
                        },
                        [_vm._v("\n            通过")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "3", border: "", size: "medium" },
                          model: {
                            value: _vm.form.batchstatus,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "batchstatus", $$v)
                            },
                            expression: "form.batchstatus"
                          }
                        },
                        [_vm._v("\n            驳回")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", autocomplete: "off" },
                        model: {
                          value: _vm.form.check_remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "check_remark", $$v)
                          },
                          expression: "form.check_remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogFormVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.batchCheck }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b10efbce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b10efbce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims/ClaimsList.vue
// module id = null
// module chunks = 